import { useLayoutEffect } from 'react';

// Legacy forms predate the shared portal. Scope their control identifiers to the
// owning dialog; explicit identifiers always take precedence.
export const useLegacyControlIds = (ref, prefix) => {
  useLayoutEffect(() => {
    const root=ref.current;
    if(!root)return;
    const slug=value=>String(value||'control').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,70);
    const identify=()=>{
      const counts={};
      root.querySelectorAll('button,input,select,textarea,[role="button"],a,.sirix-section-header,.sirix-modal-title').forEach(el=>{
        if(el.dataset.testid)return;
        const label=el.getAttribute('aria-label')||el.getAttribute('placeholder')||el.closest('label')?.textContent||el.parentElement?.querySelector('label')?.textContent||el.textContent||el.getAttribute('type');
        const name=`${prefix}-${slug(label)}-${el.tagName.toLowerCase()}`;
        const existing=root.querySelectorAll(`[data-testid^="${name}"]`).length;
        counts[name]=Math.max(counts[name]||0,existing)+1;
        el.dataset.testid=`${name}-${counts[name]}`;
      });
    };
    identify();
    const observer=new MutationObserver(identify);
    observer.observe(root,{childList:true,subtree:true});
    return()=>observer.disconnect();
  },[ref,prefix]);
};